import { useMemo } from "react";
import { useSelector } from "react-redux";
import style from "../style";
import theme from "../theme";


export const useCssStyle = () => {
    const dynamicStyle = useSelector(state => state.dynamicStyleSlice.dynamicStyle);

    return useMemo(() => (classArr) => {
        return classArr.reduce((acc, className) => {

            if (!className) return acc;
            
            if (typeof className === "object") {
                return { ...acc, ...className };
            } else {
                return { ...acc, ...style[className], ...theme[className], ...dynamicStyle[className] };
            }
        }, {});
    }, [dynamicStyle]);
};